import React from 'react'
import { SpinnerContainer, StyledSpinner } from './LoaderStyle';

const Loader = () => {
  return (
    <SpinnerContainer>
      <StyledSpinner></StyledSpinner>
    </SpinnerContainer>
  );
}


export default Loader